import { render, staticRenderFns } from "./JlzcHome.vue?vue&type=template&id=31adaf39&scoped=true"
import script from "./JlzcHome.vue?vue&type=script&lang=js"
export * from "./JlzcHome.vue?vue&type=script&lang=js"
import style0 from "./JlzcHome.vue?vue&type=style&index=0&id=31adaf39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31adaf39",
  null
  
)

export default component.exports